//Server URL
import { Capacitor } from '@capacitor/core';
import { getDomain } from './domain';

// Check if running in Capacitor native app (iOS/Android)
export const isCapacitor = () => {
  return Capacitor.isNativePlatform();
};

// Which surface the app is being used from: ANDROID, IOS, PWA (installed web app), or WEB
export const getAppPlatform = () => {
  if (Capacitor.isNativePlatform()) {
    return Capacitor.getPlatform().toUpperCase();
  }
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return 'PWA';
  }

  return 'WEB';
};

const getBaseURL = () => {
  const capacitorApp = isCapacitor();

  if (capacitorApp) {
    const domain = getDomain();

    return `https://${domain}/api`;
  }

  return 'https://' + window.location.host + '/api'; 
};

// Get logo path based on domain
/**
 * Which respondent this build speaks for on the staff-feedback endpoints: 'S'
 * student or 'P' parent.
 *
 * Mirrors ParentUser::getScholarsByDomainUserID, which maps roll_type STUDENT
 * to user_type 'S' and everything else to 'P' -- so the SCHOLAR build is the
 * PARENT side despite its name.
 *
 * Sent because the API resolves the respondent from parent_user_linking and
 * falls back to whichever row the group-by happens to return first when the
 * client stays silent. A login holding both an S and a P link would then get
 * an arbitrary one of the two, and the two are answering different instruments.
 * The server still only accepts this from within the set the login actually
 * holds, so it is a preference, not a claim.
 */
export const getRespondentType = () =>
  (process.env.REACT_APP_ROLE || 'SCHOLAR').trim().toUpperCase() === 'STUDENT' ? 'S' : 'P';

export const getLogoPath = () => {
  const domain = getDomain();

  // Return mapped logo or default ClassPep logo
  return `https://${domain}/ClassPepRecLogo.png`;
};

export default getBaseURL;